"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getExperimentalData = void 0;
const getBoilingPoint_1 = require("./getBoilingPoint");
const getFlashPoint_1 = require("./getFlashPoint");
const getMeltingPoint_1 = require("./getMeltingPoint");
const getRefractiveIndex_1 = require("./getRefractiveIndex");
const getSolubility_1 = require("./getSolubility");
const getVaporPressure_1 = require("./getVaporPressure");
/**
 * Returns the experimental data of a compound
 * @param data Data of a compound data request to the PubChem API
 * @param options Options for the compound
 * @returns ExperimentalData
 */
function getExperimentalData(data, options) {
    return {
        boilingPoint: (0, getBoilingPoint_1.getBoilingPoint)(data, options),
        flashPoint: (0, getFlashPoint_1.getFlashPoint)(data, options),
        meltingPoint: (0, getMeltingPoint_1.getMeltingPoint)(data, options),
        solubility: (0, getSolubility_1.getSolubility)(data),
        vaporPressure: (0, getVaporPressure_1.getVaporPressure)(data, options),
        refractiveIndex: (0, getRefractiveIndex_1.getRefractiveIndex)(data),
    };
}
exports.getExperimentalData = getExperimentalData;
//# sourceMappingURL=getExperimentalData.js.map